import "core-js/modules/es.array.concat.js";
// imported from packages/ab-common/src/pages/ProgramPage/EnglishRequirementException/EnglishRequirementException.jsx
import React from 'react';
import {
// TODO: use the new Accordion component. See: https://applyboard.atlassian.net/browse/RPJ-1079
AccordionLegacy, AccordionSummary, AccordionDetails, TableContainer, Table, TableBody, TableCell, TableHead, TableRow } from '@applyboard/ui-components';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
var TestNameTableCellStyle = {
  width: '200px',
  minWidth: '200px'
};
var ExceptionTableCellStyle = {
  width: '400px',
  minWidth: '400px'
};
function renderException(hasBand, minAnyBandCount, minAnyBand, testId) {
  if (hasBand) {
    return /*#__PURE__*/React.createElement(TableCell, {
      "data-testid": "".concat(testId, "-has-exception"),
      align: "center"
    }, "Up to ".concat(minAnyBandCount, " band of ").concat(minAnyBand, " or higher is permitted"));
  }
  return /*#__PURE__*/React.createElement(TableCell, {
    "data-testid": "".concat(testId, "-na-exception"),
    align: "center"
  }, "N/A");
}
function doesAcceptToefl(minToeflListening, minToeflReading, minToeflSpeaking, minToeflWriting, minToeflTotal) {
  return minToeflListening !== null && minToeflReading !== null && minToeflSpeaking !== null && minToeflWriting !== null && minToeflTotal !== null;
}
function doesAcceptIelts(minIeltsListening, minIeltsReading, minIeltsSpeaking, minIeltsWriting, minIeltsAverage) {
  return minIeltsListening !== null && minIeltsReading !== null && minIeltsSpeaking !== null && minIeltsWriting !== null && minIeltsAverage !== null;
}
function doesHaveBand(minAnyBand, minAnyBandCount) {
  return minAnyBand !== null && minAnyBandCount !== null;
}
function doesAcceptPte(minPteListening, minPteReading, minPteSpeaking, minPteWriting, minPteOverall) {
  return minPteListening !== null && minPteReading !== null && minPteSpeaking !== null && minPteWriting !== null && minPteOverall !== null;
}
function doesAcceptDuolingo(minDuolingoScore) {
  return minDuolingoScore !== null;
}
var EnglishRequirementException = function EnglishRequirementException(_ref) {
  var item = _ref.item;
  var acceptToefl = doesAcceptToefl(item.minToeflListening, item.minToeflReading, item.minToeflSpeaking, item.minToeflWriting, item.minToeflTotal);
  var acceptIelts = doesAcceptIelts(item.minIeltsListening, item.minIeltsReading, item.minIeltsSpeaking, item.minIeltsWriting, item.minIeltsAverage);
  var acceptPte = doesAcceptPte(item.minPteListening, item.minPteReading, item.minPteSpeaking, item.minPteWriting, item.minPteOverall);
  var acceptDuolingo = doesAcceptDuolingo(item.minDuolingoScore);
  var hasToeflBand = doesHaveBand(item.minToeflAnyBand, item.minToeflAnyBandCount); // for future-proofing
  var hasIeltsBand = doesHaveBand(item.minIeltsAnyBand, item.minIeltsAnyBandCount);
  var hasPteBand = doesHaveBand(item.minPteAnyBand, item.minPteAnyBandCount); // for future-proofing
  var hasException = hasToeflBand || hasIeltsBand || hasPteBand;
  return /*#__PURE__*/React.createElement(AccordionLegacy, null, /*#__PURE__*/React.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, item.countryName), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    style: TestNameTableCellStyle
  }, "Test Name"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, "L"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, "R"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, "S"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, "W"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, "O"), hasException && /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: ExceptionTableCellStyle
  }, "EXCEPTION"))), /*#__PURE__*/React.createElement(TableBody, null, acceptToefl && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    component: "th",
    scope: "row"
  }, "TOEFL"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minToeflListening), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minToeflReading), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minToeflSpeaking), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minToeflWriting), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minToeflTotal), hasException && renderException(hasToeflBand, item.minToeflAnyBandCount, item.minToeflAnyBand, 'toefl')), acceptIelts && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    component: "th",
    scope: "row"
  }, "IELTS"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minIeltsListening), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minIeltsReading), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minIeltsSpeaking), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minIeltsWriting), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minIeltsAverage), hasException && renderException(hasIeltsBand, item.minIeltsAnyBandCount, item.minIeltsAnyBand, 'ielts')), acceptPte && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    component: "th",
    scope: "row"
  }, "PTE"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minPteListening), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minPteReading), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minPteSpeaking), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minPteWriting), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minPteOverall), hasException && renderException(hasPteBand, item.minPteAnyBandCount, item.minPteAnyBand, 'pte')), acceptDuolingo && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    component: "th",
    scope: "row"
  }, "Duolingo"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, item.minDuolingoScore), hasException && /*#__PURE__*/React.createElement(TableCell, {
    "data-testid": "duolingo-na-exception",
    align: "center"
  }, "N/A")))))));
};
export default EnglishRequirementException;